




























import Vue from 'vue';
import { signOut } from '@/repository/auth';
import { mapGetters } from 'vuex';
import CFooter from '../components/CFooter.vue';

export default Vue.extend({
  components: {
    CFooter,
  },
  data() {
    const dashboard = () => {
      this.$router.push('/dashboard');
    };
    const sgOut = () => {
      signOut().then(() => {
        this.$store.dispatch('fetchUser');
        this.$router.replace('/');
      });
    };

    return {
      menu: [
        {
          id: 1,
          title: 'Dashboard',
          action: dashboard,
        },
        {
          id: '2',
          title: 'Log out',
          action: sgOut,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
});
